// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : user management
// =============================================================================
//~ export {sagas} from './sagas'
//~ import * as reducers from './reducers'
//~ export {reducers}
//~ import * as actions from './actions'
//~ export {actions}
import * as views from './views';
export { views };
export const parts = true;
